import { Slider as UISlider } from "@webmotors/eleanor-ui";
import type { SliderProps as UISliderProps } from "@webmotors/eleanor-ui/webmotors/slider";

export function Slider(props: Readonly<UISliderProps>) {
  return <UISlider {...props} data-testid="bottom-sheet" />;
}

export type SliderProps = UISliderProps